var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackRefreshImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30659 5.68699L10.2466 4.74033C10.8466 5.51366 11.2199 6.40699 11.3333 7.33366H9.98659C9.89325 6.75366 9.65992 6.18699 9.30659 5.68699ZM9.98659 8.66699H11.3333C11.2199 9.59366 10.8533 10.487 10.2533 11.2603L9.31325 10.3137C9.65992 9.81366 9.89325 9.25366 9.98659 8.66699ZM9.31325 12.2137C8.53992 12.8137 7.63992 13.1737 6.71325 13.287V11.9337C7.29325 11.8337 7.85325 11.607 8.35325 11.247L9.31325 12.2137ZM5.37992 2.71366V0.666992L8.41325 3.70033L5.37992 6.66699V4.06033C3.48659 4.38033 2.04659 6.02033 2.04659 8.00033C2.04659 9.98032 3.48659 11.6203 5.37992 11.9403V13.287C2.74659 12.9603 0.713252 10.7203 0.713252 8.00033C0.713252 5.28033 2.74659 3.04033 5.37992 2.71366Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRefreshImg);
export default __webpack_public_path__ + "static/media/back-refresh-img.4ad51561a8d4ed2ac07da5ed868d8400.svg";
export { ForwardRef as ReactComponent };